export const INITIAL_STATE: State.RefinementState = {}
